import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Button, Modal, Spin, message } from "antd";
import { LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import ZenModal from "../../../ZenModal";
import liracrypt from "../../../Liracrypt/liracrypt";
import { useSelector } from "react-redux";
import ApiErrorComp from "../../../ApiErrorComp/ApiErrorComp";
import { createRoute } from "../../../../utils/CustomFunc";
import noImg from '../../../../assets/static/noImg.jpeg';
import { useLocation } from "react-router-dom";
import queryString from "query-string";

am4core.useTheme(am4themes_animated);

const ZenDonut = (props) => {
  const urlCode = useSelector(state => state.urlCode);
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const [zenModal, setZenModal] = useState();

  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);
  const [chartData, setChartData] = useState();
  const [chartConfig, setChartConfig] = useState();
  const [modal, setModal] = useState({
    type: "smodal",
    data: undefined,
    show: false,
    loading: false
  });



  const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
    setModal({ show, data, type, loading });
  };

  const createChart = (args, chart) => {
    if (args.data) {
      chart.data = args.data;

      chart.padding(args.config.chartDiv.style.padding); //Top,Right,Bottom/Left
      chart.margin(args.config.chartDiv.style.padding);

      chart.innerRadius = args.config.chartProp.innerRadius;
      //title
      if (args.config.title.enable === true) {
        var title = chart.titles.create();
        title.text = args.config.title.val;
        title.fontSize = args.config.title.fontSize;
        title.margin(args.config.title.margin[0], args.config.title.margin[1], args.config.title.margin[2], args.config.title.margin[3]);
        title.padding(args.config.title.padding[0], args.config.title.padding[1], args.config.title.padding[2], args.config.title.padding[3]);
        title.fontWeight = args.config.title.fontWeight;
        title.fill = args.config.title.color;
      }


      /* Create series */
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = args.config.pieSeries.dataFields.value;


      pieSeries.dataFields.category =
        args.config.pieSeries.dataFields.category;
      pieSeries.name = args.config.pieSeries.name;

      pieSeries.slices.template.clickable = true;
      pieSeries.slices.template.tooltipText =
        args.config.pieSeries.tooltipText;
      // console.log(args.config.pieSeries)
      // console.log(args.config.pieSeries.autoFillColor)
      if (args.config.pieSeries.dataContainsColorKey === true) {
        // console.log("AUTOFILLLLLLLLLLLLLLLL: FALSE")
        pieSeries.slices.template.propertyFields.fill = "color";
      } else {
        var listColColors = args.config.pieSeries.color;
        chart.colors.list = [];
        for (var i = 0; i < listColColors.length; i++) {
          chart.colors.list.push(am4core.color(listColColors[i]));
        }

        pieSeries.slices.template.adapter.add("fill", (fill, target) => {
          return target.dataItem
            ? chart.colors.getIndex(target.dataItem.index)
            : fill;
        });
      }



      pieSeries.slices.template.fillOpacity =
        args.config.pieSeries.fillOpacity;
      pieSeries.slices.template.strokeOpacity =
        args.config.pieSeries.strokeOpacity;
      pieSeries.slices.template.strokeWidth =
        args.config.pieSeries.strokeWidth;

      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;


      // pieSeries.slices.template.cornerRadius =
      //   args.config.pieSeries.cornerRadius;
      pieSeries.slices.template.events.on(
        "hit",
        function (ev) {
          if (chartData?.config?.zenPop?.typ === 'comboRefresh') {
            if (props.onChange) {
              let urlData = chartData?.config?.zenPop?.params;
              let changeKey = chartData?.config?.zenPop?.comboRefreshId
              urlData[changeKey] = ev.target.dataItem._id;
              props.onChange({
                apiUrl: chartData?.config?.zenPop?.api,
                urlData,
                changeKey
              });
            }
          } else {
            onColumnClick(ev.target.dataItem.dataContext);
          }
        },
        this
      );
      if (args.config.pieSeries.shadow.enable === true) {
        var shadow = pieSeries.filters.push(new am4core.DropShadowFilter());
        shadow.dx = args.config.pieSeries.shadow.dx;
        shadow.dy = args.config.pieSeries.shadow.dy;
        shadow.blur = args.config.pieSeries.shadow.blur;
        chart.current = chart;
      }



      if (args.config.valueLabel.enable === true) {
        pieSeries.ticks.template.disabled = true;
        pieSeries.labels.template.fontSize = args.config.valueLabel.fontSize;
        pieSeries.labels.template.fill = args.config.valueLabel.color;
        pieSeries.labels.template.text = args.config.valueLabel.val;
        pieSeries.alignLabels = args.config.valueLabel.alignLabels;
        pieSeries.labels.template.radius = am4core.percent(args.config.valueLabel.radius);
        // var valueLabel = pieSeries.bullets.push(new am4charts.LabelBullet());
        // valueLabel.label.text = args.config.valueLabel.val;
      }
      else {
        pieSeries.labels.template.disabled = true;
        pieSeries.ticks.template.disabled = true;
      }





      if (args.config.watermark.enable === true) {
        var watermark = new am4core.Image();
        watermark.href = args.config.watermark.href;
        chart.plotContainer.children.push(watermark);
        watermark.align = args.config.watermark.align;
        watermark.valign = args.config.watermark.valign;
        watermark.opacity = args.config.watermark.opacity;
        watermark.marginRight = args.config.watermark.marginRight;
        watermark.marginBottom = args.config.watermark.marginBottom;
      }
    }
  };

  const getApiChartData = () => {
    liracrypt.get(props.api, props.urlData).then(response => {
      if (!response.data.data[props.divId]) {
        return;
      }
      if (props.setChartId) {
        props.setChartId(response.data.data[props.divId].meta._id);
      }
      if (props.setChartDataSource) {
        props.setChartDataSource(response.data.data[props.divId].meta.autoMan);
      }
      setChartData(response.data.data[props.divId]);
      // setTimeout(() => {
      //   chart = am4core.create(props.divId, am4charts.PieChart)
      //   createChart({ config: response.data.data[props.divId].config, data: response.data.data[props.divId].data }, chart);
      // }, 500);
    }
    ).catch(err => {
      console.log(err);
    })
  }

  useEffect(() => {
    if (props.refreshChart) {
      getApiChartData();
    }
  }, [props.refreshChart])

  useEffect(() => {
    var chart = null;
    if (props.api) {
      getApiChartData();
    } else if (props.data) {
      setChartData({ data: props.data, config: props.config });
      // setTimeout(() => {
      //   chart = am4core.create(props.divId, am4charts.PieChart)
      //   createChart({ config: props.config, data: props.data }, chart);
      // }, 500);
    };
  }, [props?.data]);

  useEffect(() => {
    var chart = null;
    if (chartData) {
      chart = am4core.create(props.divId, am4charts.PieChart)
      createChart({ data: chartData.data, config: chartData.config }, chart);
      return () => {
        chart.dispose();
      };
    }
  }, [chartData]);

  useEffect(() => {
    let interval;
    if (chartData?.config?.dataRefreshInterval) {
      interval = setInterval(() => {
        getApiChartData();
      }, chartData?.config?.dataRefreshInterval);
    };
    return () => clearInterval(interval);
  }, [chartData?.config?.dataRefreshInterval]);

  const zenPopupAction = (zenPopup, value, record) => {
    let urlData = { ...searchParams, ...props.urlData, ...zenPopup.params };
    if (zenPopup?.props) {
      urlData[zenPopup?.props] = value;
    }
    if (zenPopup?.multiProps) {
      zenPopup?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    }
    if (zenPopup?.typ === 'smodal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          id: value,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'route') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          route: zenPopup?.route,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    }
    if (zenPopup?.api) {
      toggleModal({ show: true, loading: true, type: zenPopup?.typ });
      liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
        toggleModal({
          show: true,
          data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: zenPopup?.typ
        })
      });
      return;
    }
    return toggleModal({
      show: true,
      data: zenPopup?.data,
      loading: false,
      type: zenPopup?.typ
    })
  }

  const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
    if (popData.method === 'GET') {
      liracrypt.get(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'POST') {
      liracrypt.post(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          console.log(err);
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'PATCH') {
      liracrypt.patch(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
  }

  const onColumnClick = (record) => {
    if (chartData?.config?.zenPop) {
      let zenPopDataIndex = { ...chartData?.config?.zenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  const onMenuClick = (record = {}) => {
    if (chartData?.config?.menuZenPop) {
      let zenPopDataIndex = { ...chartData?.config?.menuZenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  return (
    <div>
      {chartData?.data ? (
        <>
          {
            chartData?.config?.menuZenPop?.enable ?
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => onMenuClick()} type="link" icon={
                  <MoreOutlined />}>{''}</Button>
              </div> : <></>
          }
          <div
            id={props.divId}
            style={
              chartData.config.chartDiv.style
            }
          ></div>
          <ZenModal
            modal={modal}
            toggleModal={toggleModal}
            smodalCallback={props.api ? getApiChartData : props.smodalCallback}
            refreshData={props.api ? (params) => getApiChartData({ params }) : (params) => props.refreshData({ ...params })}
            zenModal={zenModal}
          />        </>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default ZenDonut;